/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import {checkIsActive} from "../../../../_helpers";

//actions:
import {queryActions} from "../../../../../app/redux/Query/queryRedux";

//components:
import TracksDropdown from "./TracksDropdown";

const HeaderMenu = ({layoutProps}) => {
    const location = useLocation();
    const {t} = useTranslation();

    //redux:
    const dispatch = useDispatch();
    const clearSearcher = () => dispatch(queryActions.clearSearcher());
    const showSearchResults = useSelector(state => state.query.showResults);

    const getMenuItemActive = (url, exact) => {
        return checkIsActive(location, url, exact) ? "menu-item-active" : "";
    };

    return (
        <div
            id="kt_header_menu"
            className={`header-menu header-menu-left header-menu-mobile ${layoutProps.ktMenuClasses}`}
            {...layoutProps.headerMenuAttributes}
        >
            {/*begin::Header Nav*/}
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                <li className="menu-item menu-item-rel">
                    <a
                        href="/homepage"
                        className={`menu-link text-white ${
                            getMenuItemActive("/homepage", true) ? "active_navlink" : ""
                        }`}
                        onClick={() => {
                            if (showSearchResults) clearSearcher();
                        }}
                    >
                        <span className="menu-text text-white">{t("HEADER.BUTTONTEXT.HOME")}</span>
                    </a>
                </li>

                {/* tracks DROPDOWN: */}
                <li className="menu-item menu-item-rel p-0 cursor-pointer tour-trackbutton">
                    <TracksDropdown />
                </li>
            </ul>
            {/*end::Header Nav*/}
        </div>
    );
};

export default HeaderMenu;
